import { render, staticRenderFns } from "./RomfordCity.vue?vue&type=template&id=15620750&scoped=true&"
import script from "./RomfordCity.vue?vue&type=script&lang=js&"
export * from "./RomfordCity.vue?vue&type=script&lang=js&"
import style0 from "./RomfordCity.vue?vue&type=style&index=0&id=15620750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15620750",
  null
  
)

export default component.exports